import React, { useState, useMemo, useEffect } from 'react';
import { Select, MenuItem } from '@material-ui/core';
import Strapi from '../../services/strapi';

interface StrapiChooseProps {
    value: any,
    onChange: (value: any) => void,
    collection_name: string,
    field: string,
}

const StrapiChoose = (props: StrapiChooseProps) => {
    const [options, setOptions] = useState<any[]>([]);
    const values = useMemo(() => options.map((e, i) => {
        return <MenuItem key={i} value={e}>
            {e[props.field]}
        </MenuItem>
    }), [options, props.field]);

    useEffect(() => {
        Strapi.get(props.collection_name).then((r) => {
            setOptions(r);
            
        });
    }, [props.collection_name]);

    return <Select fullWidth value={props.value} onChange={(e) => {
        props.onChange(e.target.value);
    }}>
        {values}
    </Select>
}

export default StrapiChoose;